import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "../contexts/LocaleContext";
import "../css/header.scss";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const Header = ({ isCollapsed, setIsCollapsed, setMobileSidebarOpen }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    Cookies.remove("token");
    navigate("/");
  };

  const username = Cookies.get("username");
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const onDocClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  return (
    <header className={`main-header ${isCollapsed ? "collapsed" : ""}`}>
      {/* nav */}
      <nav className="main-navbar navbar navbar-expand-lg navbar-light shadow-2">
        <div className="lnav-box d-flex">
          {/* mobile hamburger - visible on small screens */}
          <div
            className="mobile-toggle d-md-none px-3 mobile_list_ico"
            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
            onClick={() =>
              setMobileSidebarOpen && setMobileSidebarOpen((s) => !s)
            }
            aria-label="Toggle sidebar"
          >
            <svg
              viewBox="0 0 24 24"
              width={26}
              height={26}
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="5" cy="6" r="1.2" fill="#474a61" />
              <circle cx="5" cy="12" r="1.2" fill="#474a61" />
              <circle cx="5" cy="18" r="1.2" fill="#474a61" />
              <path
                d="M9 6h10M9 12h10M9 18h10"
                stroke="#474a61"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div
            className="logo-wrapper px-3 d-none d-md-flex"
            style={{ cursor: "pointer" }}
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            {isCollapsed ? (
              <svg viewBox="0 0 1024 1024" p-id={3138} width={30} height={30}>
                <path
                  d="M581.632 781.824L802.816 563.2H99.328a51.2 51.2 0 0 1 0-102.4h703.488l-221.184-218.624a51.2 51.2 0 0 1 0-72.192 46.592 46.592 0 0 1 68.096 0l310.272 307.2a55.296 55.296 0 0 1 0 74.752l-310.272 307.2a46.592 46.592 0 0 1-68.096 0 51.2 51.2 0 0 1 0-77.312z"
                  fill="#474a61"
                  p-id={3139}
                />
              </svg>
            ) : (
              <svg viewBox="0 0 1024 1024" p-id={50642} width={30} height={30}>
                <path
                  d="M0 0h1024v1024H0z"
                  fill="#474a61"
                  fillOpacity={0}
                  p-id={50643}
                />
                <path
                  d="M170.667 213.333H768q42.667 0 42.667 42.667T768 298.667H170.667Q128 298.667 128 256t42.667-42.667zM170.667 469.333h682.666Q896 469.333 896 512t-42.667 42.667H170.667Q128 554.667 128 512t42.667-42.667zM170.667 725.333h384q42.666 0 42.666 42.667t-42.666 42.667h-384Q128 810.667 128 768t42.667-42.667z"
                  fill="#474a61"
                  p-id={50644}
                />
              </svg>
            )}
          </div>
        </div>
        <div className="pr-6">
          <div className="nav sec-nav navbar-nav flex-row">
            <div className="user-item nav-item" ref={menuRef}>
              <div
                className="user-link nav-link d-inline-flex align-items-center h-100 small-1 pl-1 pl-sm-3 pr-0"
                id="dropdownAdmin_02"
              >
                <button
                  className="user-toggle d-inline-flex align-items-center"
                  onClick={() => setMenuOpen((s) => !s)}
                  aria-haspopup="menu"
                  aria-expanded={menuOpen}
                >
                  <span
                    className="avatar"
                    aria-hidden="true"
                    style={{
                      marginRight: 8,
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      t="1767774141302"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="26888"
                      width="200"
                      height="200"
                    >
                      <path
                        d="M469.333333 661.333333c0-24.021333 7.936-46.165333 21.333334-64H224.085333a95.957333 95.957333 0 0 0-95.957333 96v24.618667c0 38.058667 13.610667 74.922667 38.357333 103.893333 66.816 78.250667 168.618667 116.906667 302.848 116.906667h2.133334A107.264 107.264 0 0 1 469.333333 917.333333v-42.624c-116.821333 0-200.704-31.786667-254.208-94.421333a96 96 0 0 1-22.997333-62.336v-24.661333c0-17.621333 14.336-31.957333 32-31.957334H469.333333zM469.333333 85.546667a213.333333 213.333333 0 1 1 0 426.666666 213.333333 213.333333 0 0 1 0-426.666666z m0 64a149.333333 149.333333 0 1 0 0 298.666666 149.333333 149.333333 0 0 0 0-298.666666zM747.093333 807.552l-234.282666-136.661333A85.333333 85.333333 0 0 1 597.333333 597.333333h298.666667a85.333333 85.333333 0 0 1 85.333333 84.053334l-234.24 126.165333z"
                        p-id="26889"
                      ></path>
                      <path
                        d="M756.778667 850.773333L981.333333 729.941333V896a85.333333 85.333333 0 0 1-85.333333 85.333333h-298.666667a85.333333 85.333333 0 0 1-85.333333-85.333333v-176.213333l223.914667 130.645333a21.333333 21.333333 0 0 0 20.864 0.384z"
                        p-id="26890"
                      ></path>
                    </svg>
                  </span>
                  <span className="username-text">{username}</span>
                </button>

                {menuOpen && (
                  <div className="user-dropdown" role="menu">
                    <div className="user-dropdown-item" aria-hidden="true">
                      {username}
                    </div>
                    <button
                      className="user-dropdown-logout"
                      onClick={handleLogout}
                      style={{
                        color: "#e11d48",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <path
                          d="M16 17l5-5-5-5"
                          stroke="#e11d48"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M21 12H9"
                          stroke="#e11d48"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M4 4h8v16H4z"
                          stroke="#e11d48"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      {t ? t("header.logout") : "退出登录"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>
      {/* /.nav */}
    </header>
  );
};

export default Header;
